import React, {
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  forwardRef,
} from "react";
import { fnGetTableById } from "@shared/api/restApi"; // BackEnd API
import SnSheet from "@shared/components/Grid/SnSheet";
import SnButton from "@shared/components/SnButton";
import SnTab from "@shared/components/SnTab";
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import { getInitFormData } from "@shared/utils/CommonUtils";
import { ExcelUploadProps } from "@widgets/commonpopup/excel-upload";
import { showDialog } from "@widgets/CommonDialog";
import { RowNode } from "ag-grid-community";

type S01WithModalProps = ExcelUploadProps & {
  modalRef?: React.RefObject<any>;
};

const ExcelUpload_S01_Validate = forwardRef<any, S01WithModalProps>(
  ({ modalRef, ...props }, ref) => {
    const { Menuprops, compareFields } = props;

    const gridref1 = useRef<any>(null);

    const { userInfo } = global(); // Login user 정보

    const [columns1, setColums1] = useState<any[]>([]); // 컬럼
    const [sheet1Columns, setSheet1Columns] = useState<any[]>([]); // 엑셀 검증 컬럼
    const [dataSource1, setDataSource1] = useState<any>();
    const [codeDataList1, setCodeDataList1] = useState<
      Record<string, string>[]
    >([]);

    const isValiCheck1 = useRef(false);

    // any 그대로 사용
    useEffect(() => {
      (async () => {
        const rtn: any = await getInitFormData();
        setColums1(rtn.grid.grid1); // 컬럼
        setSheet1Columns(rtn.grid.sheet1); // 엑셀 검증 컬럼

        // 최초 화면 오픈 시점에 엑셀 업로드 그리드 초기화
        gridref1.current?.resetGridData?.();
      })();
    }, []);

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        gridref1.current.api.stopEditing();

        if (!isValiCheck1.current) {
          await showDialog("alter", "오류체크를 진행해주세요.");
          return false;
        } else {
          return true;
        }
      },
      getOkayData: () => {
        return {
          rtnData: [collectAllRows(gridref1) || []],
        };
      },
    }));

    // 코드치환 필요 시 주입
    useEffect(() => {
      (gridref1.current as any)?.setCodeDataList?.(codeDataList1);
    }, [codeDataList1]);

    const Validation1 = async (updatevalue: boolean): Promise<boolean> => {
      //  Validation 실행하여 오류 체크
      const isValid = await gridref1.current.validateData(updatevalue);

      if (!isValid) {
        showDialog("error", "오류내역을 확인해주세요.");
        return false;
      } else {
        return true;
      }
    };

    const onGrid1BtnsClick = async (id: string) => {
      switch (id) {
        case "clearSheet1":
          gridref1.current.resetGridData();
          break;
        case "checkVali1":
          {
            gridref1.current.api.stopEditing();
            const cdItem: any[] = [];
            const cdWh: any[] = [];

            gridref1.current.api.forEachNode((node: RowNode) => {
              if (
                node.data.cd_item !== "" &&
                node.data.cd_item !== null &&
                node.data.cd_item !== undefined
              ) {
                cdItem.push(node.data.cd_item);
              }
            });

            gridref1.current.api.forEachNode((node: RowNode) => {
              if (
                node.data.cd_wh !== "" &&
                node.data.cd_wh !== null &&
                node.data.cd_wh !== undefined
              ) {
                cdWh.push(node.data.cd_wh);
              }
            });

            if (cdItem.length > 0) {
              const params1 = {
                id: "search_items",
                params: { cd_firm: userInfo.cd_firm, cd_items: cdItem },
              };
              const params2 = {
                id: "search_whs",
                params: { cd_firm: userInfo.cd_firm, cd_whs: cdWh },
              };
              const dataItem = await fnGetTableById(params1);
              const dataWh = await fnGetTableById(params2);

              if (dataItem) {
                const itemMap = new Map();
                dataItem.forEach((item: any) => {
                  itemMap.set(item.cd_item, item);
                });
                const whMap = new Map();
                dataWh.forEach((item: any) => {
                  whMap.set(item.cd_wh, item);
                });

                gridref1.current.api.forEachNode((node: RowNode) => {
                  // API 결과에서 현재 노드의 cd_item과 일치하는 정보를 찾음
                  const itemCode = node.data.cd_item;
                  const cdWh = node.data.cd_wh;
                  if (
                    itemCode !== "" &&
                    itemCode !== null &&
                    itemCode !== undefined
                  ) {
                    const matchingItem = itemMap.get(itemCode);

                    if (matchingItem) {
                      node.data.nm_item = matchingItem.nm_item;
                      node.data.dc_item_spec = matchingItem.dc_item_spec;
                      node.data.dc_item_unit = matchingItem.dc_item_unit;
                      node.data.yn_lot = matchingItem.yn_lot;
                    }
                  }
                  if (cdWh !== "" && cdWh !== null && cdWh !== undefined) {
                    const matchingWh = whMap.get(cdWh);

                    if (matchingWh) {
                      node.data.nm_wh = matchingWh.nm_wh;
                    }
                  }
                });
              }
            }

            const isValid = await Validation1(false);
            if (isValid) {
              showDialog("success", "오류가 없습니다.");
              isValiCheck1.current = true;
            } else {
              isValiCheck1.current = false;
            }
          }
          break;
      }
    };

    // 1) 필드 목록: sheet1Columns 우선, 없으면 첫 행 키로 폴백 (1회 계산)
    const hasInput = (row: any) => {
      const fields = (sheet1Columns ?? [])
        .map((c: any) => c?.field)
        .filter(Boolean);

      const check = (v: any) =>
        v === 0 || v === false || (v != null && String(v).trim() !== "");

      if (fields.length > 0) {
        return fields.some((f) => check(row[f]));
      }

      // fallback: schema 없을 때만 KeyField 제외
      return Object.entries(row)
        .filter(([k]) => k !== "KeyField")
        .some(([, v]) => check(v));
    };

    const collectAllRows = (grid: any) => {
      const api = grid.current?.api;
      if (!api) return [];
      const out: any[] = [];
      api.forEachNode((node: any) => {
        const r = node?.data;
        if (r && hasInput(r)) out.push({ ...r });
      });
      return out;
    };

    return (
      <div className="h-full flex flex-col">
        <SnTab
          titles={["대체품목정보"]}
          width={"100%"}
          header={[
            <div>
              <SnButton
                text={"초기화"}
                onClick={() => {
                  onGrid1BtnsClick("clearSheet1");
                }}
              />
              <SnButton
                text={"오류체크"}
                onClick={() => {
                  onGrid1BtnsClick("checkVali1");
                }}
              />
            </div>,
          ]}
          body={[
            <div className="flex-1 h-full min-h-0 space-y-1.5">
              <SnSheet
                menuInfo={Menuprops}
                ref={gridref1}
                enableAddRow={true}
                columnConfig={sheet1Columns}
                rowData={dataSource1}
                isEditable={true}
                codeDataList={codeDataList1}
                compareFields={compareFields ?? []}
              />
            </div>,
          ]}
        />
      </div>
    );
  }
);
export default ExcelUpload_S01_Validate;
